module.exports = __webpack_public_path__ + "img/Rollo.3e2e4d38.png";